<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoListar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoListar">
            <div class="formgroup" *ngIf="permissaoInserir">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-2">
                        <button
                            pButton
                            pRipple
                            routerLink="/apps/indicador-cliente/inserir"
                            label="Novo"
                            icon="pi pi-plus"
                            class="p-button-outlined sm:w-9rem"
                        ></button>
                    </div>
                </div>
            </div>
            <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
            <p-table
                #dt1
                [value]="listaDreAgrupada"
                dataKey="descricaoGrupo"
                [rows]="10"
                [loading]="loading"
                [rowHover]="true"
                responsiveLayout="scroll"
                styleClass=" p-datatable-sm"
            >
                <!-- <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row gap-2">
                        <div class="flex flex-column sm:flex-row w-full gap-2">
                            
                        </div>
                        
                        <div class="p-fluid">
                            <div class="flex">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input
                                        pInputText
                                        type="text"
                                        #filter
                                        (input)="buscar(dt1, $event)"
                                        placeholder="Buscar"
                                        class="w-full"
                                    />
                                </span>
                                <span class="ml-2">
                                    <button
                                        pButton
                                        class="p-button-outlined"
                                        icon="pi pi-filter-slash"
                                        pTooltip="Limpar Filtros"
                                        (click)="limpar(dt1)"
                                    ></button>
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-template> -->
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <div class="flex flex-column sm:flex-row w-full gap-2">
                            <div class="p-fluid sm:w-12rem">
                                <label htmlFor="filtroData">Ano</label>
                                <p-calendar
                                    class="p-fluid"
                                    view="year"
                                    dateFormat="yy"
                                    placeholder="Selecione"
                                    [showIcon]="true"
                                    [readonlyInput]="true"
                                    [(ngModel)]="filtroAno"
                                    (ngModelChange)="listar()"
                                ></p-calendar>
                            </div>
                            <button
                                pButton
                                pRipple
                                pTooltip="Ver detalhado em PDF"
                                [icon]="
                                    loadingRelatorio ? 'pi pi-spin pi-spinner' : 'pi pi-file-pdf'
                                "
                                [disabled]="loadingRelatorio"
                                class="p-button-outlined w-full sm:w-3rem h-3rem mt-4"
                                (click)="carregarRelatorio()"
                            ></button>
                            <div class="p-fluid">
                                <label>Mês</label>
                                <p-dropdown
                                    [options]="listaMeses"
                                    placeholder="Selecione"
                                    optionLabel="label"
                                    optionValue="value"
                                    emptyMessage="Nenhum registro"
                                    [(ngModel)]="mesSelecionado"
                                    (ngModelChange)="listar()"
                                ></p-dropdown>
                            </div>
                            <div class="p-fluid">
                                <label>Base DRE</label>
                                <p-dropdown
                                    [options]="listaBaseDre"
                                    placeholder="Selecione"
                                    emptyMessage="Nenhum registro"
                                    [(ngModel)]="baseDreSelecionada"
                                    (ngModelChange)="listar()"
                                ></p-dropdown>
                            </div>
                        </div>
                        <div class="p-fluid mt-4">
                            <div class="flex">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input
                                        pInputText
                                        type="text"
                                        #filter
                                        (input)="buscar(dt1, $event)"
                                        placeholder="Buscar"
                                        class="w-full"
                                    />
                                </span>
                                <span class="ml-2">
                                    <button
                                        pButton
                                        class="p-button-outlined"
                                        icon="pi pi-filter-slash"
                                        pTooltip="Limpar Filtros"
                                        (click)="limpar(dt1)"
                                    ></button>
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template pTemplate="body" let-item let-expanded="expanded">
                    <tr class="bg-blue-50">
                        <td style="width: 3rem">
                            <button
                                type="button"
                                pButton
                                pRipple
                                [pRowToggler]="item"
                                class="p-button-text p-button-rounded p-button-plain"
                                style="box-shadow: none"
                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                            ></button>
                        </td>

                        <td style="min-width: 12rem" class="text-lg font-semibold">
                            {{ item.descricaoGrupo }}
                        </td>
                        <td style="min-width: 12rem" class="text-lg font-semibold text-right">
                            TOTAL: {{ item.total | currency: "BRL" }}
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="rowexpansion" let-item>
                    <tr class="bg-white">
                        <td colspan="7">
                            <div class="pl-5">
                                <p-table
                                    [value]="item.dres"
                                    dataKey="descricaoDre"
                                    responsiveLayout="scroll"
                                >
                                    <ng-template
                                        pTemplate="body"
                                        let-dre
                                        let-expandedDre="expanded"
                                    >
                                        <tr>
                                            <td style="width: 3rem">
                                                <button
                                                    type="button"
                                                    pButton
                                                    pRipple
                                                    [pRowToggler]="dre"
                                                    class="p-button-text p-button-rounded p-button-plain"
                                                    style="box-shadow: none"
                                                    [icon]="
                                                        expandedDre
                                                            ? 'pi pi-chevron-down'
                                                            : 'pi pi-chevron-right'
                                                    "
                                                ></button>
                                            </td>

                                            <td
                                                style="min-width: 12rem"
                                                class="text-lg font-semibold"
                                            >
                                                {{ dre.descricaoDre }}
                                            </td>
                                            <td
                                                style="min-width: 12rem"
                                                class="text-lg font-semibold text-right"
                                            >
                                                TOTAL: {{ dre.total | currency: "BRL" }}
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="rowexpansion" let-dre>
                                        <tr class="bg-white">
                                            <td colspan="7">
                                                <div class="pl-5">
                                                    <p-table
                                                        [value]="dre.registros"
                                                        dataKey="id"
                                                        responsiveLayout="scroll"
                                                    >
                                                        <ng-template pTemplate="header">
                                                            <tr>
                                                                <th pSortableColumn="descricao">
                                                                    Data
                                                                    <p-sortIcon
                                                                        field="descricao"
                                                                    ></p-sortIcon>
                                                                </th>
                                                                <th pSortableColumn="descricao">
                                                                    Nº Registro
                                                                    <p-sortIcon
                                                                        field="descricao"
                                                                    ></p-sortIcon>
                                                                </th>
                                                                <th pSortableColumn="descricao">
                                                                    Conta
                                                                    <p-sortIcon
                                                                        field="descricao"
                                                                    ></p-sortIcon>
                                                                </th>
                                                                <th pSortableColumn="descricao">
                                                                    Identificação
                                                                    <p-sortIcon
                                                                        field="descricao"
                                                                    ></p-sortIcon>
                                                                </th>
                                                                <th pSortableColumn="descricao">
                                                                    Valor
                                                                    <p-sortIcon
                                                                        field="descricao"
                                                                    ></p-sortIcon>
                                                                </th>
                                                            </tr>
                                                        </ng-template>
                                                        <ng-template
                                                            pTemplate="body"
                                                            let-registro
                                                            let-expandedRegistro="expanded"
                                                        >
                                                            <tr>
                                                                <td>
                                                                    {{
                                                                        registro.competencia
                                                                            | date: "dd/MM/yyyy"
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{ registro.numeroRegistro }}
                                                                </td>
                                                                <td>
                                                                    {{ registro.planoConta }}
                                                                </td>
                                                                <td
                                                                    style="min-width: 12rem"
                                                                    class="text-lg font-semibold"
                                                                >
                                                                    {{ registro.identificacao }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        registro.valor
                                                                            | currency: "BRL"
                                                                    }}
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                        <ng-template pTemplate="emptymessage">
                                                            <tr>
                                                                <td colspan="6">
                                                                    Nenhum registro encontrado.
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr>
                                            <td colspan="6">Nenhum registro encontrado.</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="7">Carregando. Por favor aguarde.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-end">
                        
                        <span class="text-right" *ngIf="listaDreAgrupada.length > 0">
                            TOTAL: {{valorTotal | currency:'BRL'}}
                        </span>
                    </div>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
